module.exports = __webpack_public_path__ + "img/arrow-left.aa1749cc.svg";